import React, { useEffect, useState } from 'react';

import ExpandMore from '@mui/icons-material/ExpandMore';
import LinearProgress from '@mui/material/LinearProgress';
import {
    Box,
    Button,
    Menu,
    MenuItem,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { InputSearch } from 'common/components';

import * as projectsActions from '../../projects/actions';
import * as projectsSelectors from '../../projects/selectors';

const ProjectDropDownSelector = ({
    children,
    contactId,
    currentProjectId,
    fetchProjects,
    isFetchingProjects,
    onProjectChange,
    projects,
    size = 'medium',
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [filterData, setFilterData] = useState({ searchText: '' });
    const open = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    useEffect(() => {
        if (!open) return;
        fetchProjects({
            contactId,
            status: 'active',
            pageSize: 50,
            page: 0,
        });
    }, [open, contactId, fetchProjects]);

    const handleOnChangeSearch = (e) =>
        setFilterData((prev) => ({ ...prev, searchText: e.target.value }));

    const handleProjectSelect = (projectId) => {
        onProjectChange(projectId);
        handleClose();
    };

    const projectsFiltered = projects?.filter((project) =>
        project.name
            .toLowerCase()
            .includes(filterData.searchText.toLowerCase()),
    );

    return (
        <Box sx={{ gap: 1, display: 'flex', alignItems: 'left' }}>
            <Button
                endIcon={<ExpandMore />}
                onClick={handleClick}
                size={size}
                sx={{ color: 'text.primary' }}
                variant="text"
            >
                {children}
            </Button>

            <Menu
                anchorEl={anchorEl}
                autoFocus={false}
                disableAutoFocusItem
                onClose={handleClose}
                open={open}
                sx={{ minWidth: '300px' }}
            >
                <Box sx={{ p: 1 }} onKeyDown={(e) => e.stopPropagation()}>
                    <InputSearch
                        onChange={handleOnChangeSearch}
                        placeholder="Buscar proyecto..."
                        value={filterData?.searchText}
                    />
                </Box>

                {isFetchingProjects && <LinearProgress />}

                {!isFetchingProjects &&
                    projectsFiltered?.length > 0 &&
                    projectsFiltered?.map(({ id, name }) => (
                        <MenuItem
                            key={`menuitem-project-${id}`}
                            onClick={() => handleProjectSelect(id)}
                            selected={id === currentProjectId}
                        >
                            <Typography variant="body2">{name}</Typography>
                        </MenuItem>
                    ))}

                {!isFetchingProjects && projectsFiltered?.length === 0 && (
                    <MenuItem disabled>
                        <Typography variant="body2">
                            No se encontraron proyectos
                        </Typography>
                    </MenuItem>
                )}
            </Menu>
        </Box>
    );
};

const mapStateToProps = createStructuredSelector({
    isFetchingProjects: projectsSelectors.getIsFetchingProjects,
    projects: projectsSelectors.getProjectsData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchProjects: (filterData) =>
        dispatch(projectsActions.filterProjects(filterData)),
});

ProjectDropDownSelector.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    contactId: PropTypes.string,
    currentProjectId: PropTypes.string,
    fetchProjects: PropTypes.func,
    isFetchingProjects: PropTypes.bool,
    onProjectChange: PropTypes.func,
    projects: PropTypes.array,
    size: PropTypes.string,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProjectDropDownSelector);
